{
  "deselectedItem": "Δεν επιλέχθηκε το στοιχείο {item}.",
  "select": "Επιλογή",
  "selectedAll": "Επιλέχθηκαν όλα τα στοιχεία.",
  "selectedCount": "{count, plural, =0 {Δεν επιλέχθηκαν στοιχεία} one {Επιλέχθηκε # στοιχείο} other {Επιλέχθηκαν # στοιχεία}}.",
  "selectedItem": "Επιλέχθηκε το στοιχείο {item}."
}
